import { render } from "./PostRow.vue?vue&type=template&id=ef9bd2e4"
import script from "./PostRow.vue?vue&type=script&lang=js"
export * from "./PostRow.vue?vue&type=script&lang=js"

import "./PostRow.vue?vue&type=style&index=0&id=ef9bd2e4&lang=scss"

import exportComponent from "/Users/matteomelillo/Dev/wpHeadless/suisseconsulences.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__